import { Injectable, Injector } from '@angular/core';
import { MescService } from '../mesc/mesc.service';

@Injectable()
export class CtwrUserService extends MescService {
  constructor(injector: Injector) { super(injector, "ctwr/User"); }
}

@Injectable()
export class CtwrPartService extends MescService {
  constructor(injector: Injector) { super(injector, "ctwr/Part"); }
}

@Injectable()
export class CtwrRequestService extends MescService {
  constructor(injector: Injector) { super(injector, "ctwr/Request"); }
}

@Injectable()
export class CtwrAuthorizationTypeService extends MescService {
  constructor(injector: Injector) { super(injector, "ctwr/Request/AuthorizationType"); }
}

@Injectable()
export class CtwrDesignPhaseService extends MescService {
  constructor(injector: Injector) { super(injector, "ctwr/DesignPhase"); }
}

@Injectable()
export class CtwrPartTypeService extends MescService {
  constructor(injector: Injector) { super(injector, "ctwr/PartType"); }
}

@Injectable()
export class CtwrPartFamilyService extends MescService {
  constructor(injector: Injector) { super(injector, "ctwr/PartFamily"); }
}

@Injectable()
export class CtwrLocationService extends MescService {
  constructor(injector: Injector) { super(injector, "ctwr/Location"); }
}

@Injectable()
export class CtwrLocationApproverService extends MescService {
  constructor(injector: Injector) { super(injector, "ctwr/LocationApprover"); }
}

@Injectable()
export class CtwrProcessService extends MescService {
  constructor(injector: Injector) { super(injector, "ctwr/Process"); }
}

@Injectable()
export class CtwrComponentService extends MescService {
  constructor(injector: Injector) { super(injector, "ctwr/Component"); }
}

@Injectable()
export class CtwrComponentCategoryService extends MescService {
  constructor(injector: Injector) { super(injector, "ctwr/ComponentCategory"); }
}

@Injectable()
export class CtwrItemService extends MescService {
  constructor(injector: Injector) { super(injector, "ctwr/Item"); }
}

@Injectable()
export class CtwrProgramService extends MescService {
  constructor(injector: Injector) { super(injector, "ctwr/Program"); }
}
